<template>
  <div id="app">
    <Header></Header>
    <router-view />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  components: {
    Header
  }
};
</script>

<style lang="scss">
:root {
  --color-black: #000;
  --color-white: #fff;
  --color-gray-dark: #252525;
  --color-gray-normal: #555;
  --color-gray-medium: #999;
  --color-gray-light: #c5c5c5;
  --color-gray-white: #f5f5f5;
  --color-positive-dark: #000629;
  --color-positive-normal: #0053d7;
  --color-positive-rgb: 0, 83, 215;
  --color-balanced: #00cc99;
  --color-balanced-rgb: 0, 204, 153;
  --color-assertive: #f5104f;
  --color-assertive-rgb: 245, 16, 79;
  --grid-gutter: 16px;
  --grid-max: 800px;
  --transition: 0.2s all ease;
}

html {
  height: 100%;
}

body {
  height: 100%;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-gray-dark);
}

* {
  box-sizing: border-box;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding-bottom: 64px;
  border-bottom: 10px solid var(--color-positive-normal);

  a {
    text-decoration: none;
  }

  .section {
    &:not(:last-child) {
      margin-bottom: 64px;
    }
  }

  .main {
    flex: 1;
  }
}

input,
select {
  -webkit-appearance: none;
  display: block;
  width: 100%;
  border: 0;
  border-radius: 0;
  background-clip: padding-box;
  background-color: var(--color-white);
  outline: 0;

  &[type='input']:not(:disabled):not(.disabled) {
    cursor: text;
  }

  &:disabled,
  &.disabled {
    cursor: default;
  }

  &[type='checkbox'],
  &[type='radio'] {
    cursor: pointer;
  }
}

button {
  -webkit-appearance: none;
  user-select: none;
  display: inline-block;
  vertical-align: middle;
  white-space: nowrap;
  text-decoration: none;
  text-align: center;
  margin: 0;
  padding: 0;
  border: 0;
  background-color: transparent;
  outline: 0;

  &:not(:disabled):not(.disabled) {
    cursor: pointer;
  }
}

.wrapper {
  max-width: 800px;
  padding: 0 24px;
  margin-left: auto;
  margin-right: auto;
}

// Grid
.row {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: 768px) {
    flex-direction: row;
  }

  &:not(:last-child) {
    margin-bottom: 16px;
  }

  &:not(.direction-row) {
    > [class*='col-'] {
      @media (max-width: 768px) {
        width: 100%;
      }
    }
  }

  &-label {
    font-weight: 600;
    color: var(--color-positive-normal);
  }

  &.vertical-center {
    align-items: center;
  }

  &.direction-column {
    flex-direction: column;
    justify-content: space-between;

    [class*='col-'] {
      margin-bottom: 16px !important;
    }
  }

  &.direction-row {
    flex-direction: column;
    justify-content: center;

    [class*='col-'] {
      @media (max-width: 440px) {
        width: 100%;
      }
    }

    @media (min-width: 440px) {
      flex-direction: row;
      justify-content: space-between;

      [class*='col-'] {
        margin-bottom: 0 !important;
      }
    }
  }

  &.align-left {
    justify-content: flex-start;

    > * {
      &:not(:last-child) {
        margin-bottom: 16px;

        @media (min-width: 768px) {
          margin-right: 8px;
          margin-bottom: 0;
        }
      }
    }
  }

  &.align-end {
    justify-content: flex-start;
  }

  &.align-center {
    justify-content: center;

    .control {
      width: auto;
    }
  }

  &.align-center-space {
    justify-content: space-around;

    .control {
      width: auto;

      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }
  }
}

@for $i from 1 through 12 {
  .col-#{$i} {
    width: 100% / 12 * $i;

    &:not(:last-child) {
      margin-bottom: 16px;

      @media (min-width: 768px) {
        margin-bottom: 0;
      }
    }

    @media (min-width: 768px) {
      margin: 0 8px;
    }
  }
}
</style>
